import type { ICountry } from '@/domain/core';

const ISO3_TO_ISO2: Record<string, string> = {
  MEX: 'MX',
  COL: 'CO',
  PER: 'PE',
  CHL: 'CL',
  ARG: 'AR',
};

const ISO2_TO_ISO3: Record<string, ICountry> = {
  MX: 'MEX',
  CO: 'COL',
  PE: 'PER',
  CL: 'CHL',
  AR: 'ARG',
};

const CURRENCY: Record<string, string> = {
  MEX: 'MXN',
  COL: 'COP',
  PER: 'PEN',
  CHL: 'CLP',
  ARG: 'ARS',
};

export const toIso2 = (iso3: string): string => ISO3_TO_ISO2[iso3] ?? 'MX';

export const toIso3 = (iso2: string): ICountry => ISO2_TO_ISO3[iso2] ?? 'MEX';

export const currencyFor = (iso3: string): string => CURRENCY[iso3] ?? 'MXN';
